import I18n from '@ringcentral-integration/i18n';
import loadLocale from './loadLocale';

export default new I18n(loadLocale);
